import { Card } from '@/components/ui/card';
import { Lightbulb, FileText, Share2, Trophy } from 'lucide-react';

const rules = [
  {
    icon: Lightbulb,
    title: 'Dream Big',
    description: 'One idea per person — Make it as crazy or as practical as you want — the sky (and budget) is the limit.',
    gradient: 'from-primary to-primary/50'
  },
  {
    icon: FileText,
    title: 'Keep it Clear',
    description: '500–1,000 words + optional mockup or 60-second video. The clearer, the better.',
    gradient: 'from-secondary to-secondary/50'
  },
  {
    icon: Share2,
    title: 'Share the Hype',
    description: 'Post your idea on X with #DreamSaaSEmpire and tag @LayoutDev — we\'ll repost the best ones.',
    gradient: 'from-accent to-accent/50'
  },
  {
    icon: Trophy,
    title: 'Prizes on the Table',
    description: '1st Place → $500 Layout.dev credits | 5 Runners-up → $100 credits each | Everyone gets a 10% discount code just for entering.',
    gradient: 'from-primary via-secondary to-accent'
  }
];

export const QuickRules = () => {
  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
          Quick Rules
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {rules.map((rule, index) => {
            const Icon = rule.icon;
            return (
              <Card
                key={index}
                className="group relative p-8 bg-card/50 backdrop-blur-sm border-border/50 hover:border-accent/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(96,165,250,0.3)] hover:-translate-y-2"
              >
                {/* Gradient background on hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${rule.gradient} opacity-0 group-hover:opacity-10 transition-opacity rounded-lg`} />

                {/* Icon */}
                <div className={`relative mb-6 w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${rule.gradient}`}>
                  <Icon className="w-8 h-8 text-white" />
                </div>

                {/* Title */}
                <h3 className="relative text-xl font-bold mb-4 text-foreground">
                  {rule.title}
                </h3>

                {/* Description */}
                <p className="relative text-sm leading-relaxed text-muted-foreground">
                  {rule.description}
                </p>

                {/* Corner accent */}
                <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br ${rule.gradient} opacity-20 blur-2xl`} />
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
